import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: theme.spacing(2),
    },
  })
);
